import { Component, OnInit, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import {
    POPUP_VISIBILITY_HAS_CHANGED,
    POP_UP_WIDTH,
    POP_UP_HEIGHT, CARD_WIDTH,
    CARD_HEIGHT,
    CARD_MARGIN
} from "../../../../app.constants";
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/throttleTime';
import { EventsService } from "../../../../core/services/events.service";
import { CartService } from "../../../../core/services/cart.service";
import { UserService } from "../../../../core/services/user.service";
import { AuthenticationService } from "../../../../core/services/authentication.service";

@Component({
    selector: 'product-popup',
    templateUrl: './product-popup.component.html',
    styleUrls: ['./product-popup.component.scss']
})

export class ProductPopupComponent implements OnInit {
    offsetTop: string;
    offsetLeft: string;
    popUpHeight: string;
    popUpWidth: string;
    visibility: string;
    opacity: number;
    productInfo: any;
    isRender: boolean;


    constructor(private eventsService: EventsService,
                private elementRef: ElementRef,
                private router: Router,
                private cartService: CartService,
                private userService: UserService,
                private authenticationService: AuthenticationService) {
        this.offsetTop = '0px';
        this.offsetLeft = '0px';
        this.popUpHeight = '0px';
        this.visibility = 'hidden';
        this.opacity = 0;
        this.productInfo = {};

    }

    ngOnInit() {
        this.eventsService.on(POPUP_VISIBILITY_HAS_CHANGED).debounceTime(500).subscribe((popUpData: any) => {
            this.renderPopUp(popUpData);
        });
    }

    renderPopUp(popUpData) {
        if (!popUpData.display) {
            if (!this.isRender) {
                this.hidePopUp();
            }
            return;
        }

        let left, top;
        const node = this.elementRef.nativeElement.childNodes[0];

        if (window.innerWidth - popUpData.clientX - this.convertVwToPx(CARD_WIDTH) > POP_UP_WIDTH || popUpData.clientX < POP_UP_WIDTH) {
            left = popUpData.clientX + this.convertVwToPx(CARD_WIDTH) - this.convertVwToPx(CARD_MARGIN);
            if (node.children[1].className === 'courses-carousel-component__popup__arrow-right') {
                node.children[1].className = 'courses-carousel-component__popup__arrow';
                this.swapNodes(node);
            }
        } else {
            left = popUpData.clientX - POP_UP_WIDTH + this.convertVwToPx(CARD_MARGIN);
            if (node.children[1].className !== 'courses-carousel-component__popup__arrow-right') {
                node.children[0].className = 'courses-carousel-component__popup__arrow-right';
                this.swapNodes(node);
            }
        }
        top = popUpData.clientY + (this.convertVwToPx(CARD_HEIGHT) - POP_UP_HEIGHT) / 2;

        this.popUpHeight = POP_UP_HEIGHT + 'px';
        this.popUpWidth = POP_UP_WIDTH + 'px';
        this.offsetLeft = left + 'px';
        this.offsetTop = top + 'px';
        this.productInfo = popUpData.productCard;
        this.visibility = 'visible';
        this.opacity = 1;
    }

    hidePopUp() {
        this.offsetTop = 0 + 'px';
        this.offsetLeft = 0 + 'px';
        this.popUpHeight = 0 + 'px';
        this.popUpWidth = 0 + 'px';
        this.visibility = 'hidden';
        this.opacity = 0;
        this.productInfo = {};
    }

    convertVwToPx(value: number): number {
        return (value * window.innerWidth) / 100;
    }

    swapNodes(node) {
        const card = node.children[1];
        card.parentNode.insertBefore(card, node.children[0]);
    }

    mouseEnter() {
        this.isRender = true;
    }

    mouseLeave() {
        this.isRender = false;
        this.hidePopUp();
    }

    isProductInTheCart() {
        if (this.authenticationService.isAuthenticated()) {
            return this.cartService.isProductInTheCart(this.productInfo.id);
        }
    }

    isProductPurchased() {
        if (this.authenticationService.isAuthenticated()) {
            return this.userService.isProductPurchased(this.productInfo.id);
        }
    }

    addToBasket() {
        if(this.authenticationService.isAuthenticated()) {
            this.cartService.addProductToCart(this.productInfo);
        } else {
            this.router.navigate([{ outlets: { popup: 'login' }}]);
        }
    }

    removeFromBasket() {
        this.cartService.removeProductFromCart(this.productInfo);
    }

}




// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/pages/home/components/product-popup/product-popup.component.ts